import SortOrderSwitcher from './SortOrderSwitcher';
import SortOrderSwitcherContainer from './SortOrderSwitcher.container';

export default SortOrderSwitcherContainer(
  SortOrderSwitcher
);
